<template>
  <div>
    <v-row dense class="mx-1 mt-1" v-if="initialSelectionCount > 0 ">
      <v-col cols="12">
        <v-alert
          type="success"
          outlined
          v-once
          class="rounded-tag-small body-2"
          dismissible>
        Selecionamos {{ initialSelectionCount }} {{ fornecedor }} baseado nos produtos cotados
        </v-alert>
      </v-col>
    </v-row>
    <v-row dense class="mx-1 mt-1">
      <span class="caption mt-2">{{ values.length }} selecionado(s)</span>
        <v-btn v-if="values.length"
               x-small text
               class="normal-btn-text mt-2"
               color="error"
               @click="onClickClose">
          <v-icon x-small>mdi-close</v-icon>
          limpar
        </v-btn>
      <v-spacer/>
      <px-fornecedor-filter :filters="filters"
                            @change="onUpdateAdvancedFilters"/>
      <px-search-text label="Busque por um CNPJ, fornecedor ou código interno."
                      v-model="filters.searchText"
                      class="rounded-tag-small"
                      style="max-width: 400px"
                      :on-search="onUpdateFilters"/>
    </v-row>
    <px-selecao-fornecedores-selecionados :fornecedores="values"
                                          @remove="onRemoveItem"/>
  </div>
</template>

<script>
import PxSelecaoFornecedoresSelecionados
  from '@/components/lista-selecao-fornecedor/PxSelecaoFornecedoresSelecionados.vue';
import PxFornecedorFilter from './PxFornecedorFilter.vue';

export default {
  props: {
    initialSelectionCount: {
      type: Number,
    },
    values: Array,
  },
  data() {
    return {
      filters: {
        searchText: null,
        estados: [],
        municipios: [],
      },
      alert: true,
    };
  },
  computed: {
    fornecedor() {
      return this.values.length > 1 ? 'fornecedores' : 'fornecedor';
    },
  },
  methods: {
    onUpdateAdvancedFilters({ estados, municipios }) {
      this.filters.estados = estados;
      this.filters.municipios = municipios;
      this.onUpdateFilters();
    },
    onUpdateFilters() {
      this.$emit('change', this.filters);
    },
    onClickClose() {
      this.$emit('resetfornecedor');
    },
    onRemoveItem(fornecedor) {
      this.$emit('remove', fornecedor);
    },
  },
  components: {
    PxFornecedorFilter,
    PxSelecaoFornecedoresSelecionados,
  },
};
</script>
